<form [formGroup]="recordForm" (ngSubmit)="onSubmit()" class="px-2">
  <div class="modal-header">
    <h4 class="modal-title">{{ dialogDetails?.title }}</h4>
    <!-- <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="dismiss()"
    ></button> -->
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12 mb-3">
        <p class="mb-2">
          This action is irreversible. Your subscription will be cancelled and
          you may lose access to services.
        </p>
        <small class="text-muted d-block mb-2">
          To proceed with cancellation, type
          <strong>'{{ requiredConfirmationMsg }}'</strong> to confirm.
        </small>

        <input
          class="form-control"
          type="text"
          formControlName="confMsg"
          placeholder="Enter Confirmation Message"
        />

        <div
          class="text-danger mt-1"
          *ngIf="
            recordForm.get('confMsg')?.touched &&
            recordForm.get('confMsg')?.value?.trim() !== requiredConfirmationMsg
          "
        >
          Confirmation message does not match.
        </div>

        <div
          class="text-success mt-1"
          *ngIf="
            recordForm.get('confMsg')?.value?.trim() === requiredConfirmationMsg
          "
        >
          Confirmation message verified!
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="activeModal.close('Close click')"
    >
      Cancel
    </button>
    <button
      class="btn btn-danger"
      type="submit"
      [disabled]="
        recordForm.get('confMsg')?.value?.trim() !== requiredConfirmationMsg
      "
    >
      Confirm Cancellation
    </button>
  </div>
</form>
